export default {"src":"/_next/static/media/affiliate-bg.332d0345.svg","height":124,"width":145,"blurWidth":0,"blurHeight":0};